<div class="machine-list-wrapper">
  <app-subgroup-machine-item *ngFor="let machine of machineList" [machine]="machine">
  </app-subgroup-machine-item>
</div>
